import { IconTrash } from "@tabler/icons-react"
import { createColumnHelper } from "@tanstack/react-table"
import { ActionIcon, TextCell } from "@tfg/ui"
import { useMemo } from "react"

import { FindAllActivitiesResponseDto } from "~/gen/api"
import { useDeleteActivityMutation } from "~/pages/Admin/Ingestion/Activities/hooks/useDeleteActivityMutation"

const columnHelper = createColumnHelper<FindAllActivitiesResponseDto>()

export const useColumns = (activities: FindAllActivitiesResponseDto[]) => {
  const { mutate: deleteActivity } = useDeleteActivityMutation()

  return useMemo(
    () => [
      columnHelper.accessor("id", {
        header: "ID",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor("name", {
        header: "Name",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor((row) => row.id, {
        header: () => null,
        id: "action-cell-delete",
        enableSorting: false,
        cell: ({ row }) => (
          <ActionIcon
            icon={<IconTrash />}
            onClick={() => deleteActivity(row.original.id)}
          />
        ),
      }),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activities]
  )
}
